<template>
  <Card
    :class="[$style.card,{
      [$style.error]: error,
    }]"
  >
    <div
      v-if="iconComponent"
      :class="[icon.withBackground ? $style.iconWithBackground : $style.icon]"
    >
      <component
        :is="iconComponent"
        v-bind="icon.props"
      />
    </div>
    <div
      :class="[$style.content,
               {[$style.alignBottom]: alignBottom}]"
    >
      <header
        v-if="showTitle"
        :class="$style.header"
      >
        <h4 :class="$style.title">
          <div :class="$style.headerStyle">
            <slot
              name="title"
            />
            {{ title }}
          </div>
          <TooltipIcon
            v-if="tooltip"
            icon="info"
            :linkHref="tooltip.kbLink"
            linkText="Knowledge base article"
            :text="tooltip.text"
          />
        </h4>
        <h5
          v-if="subTitle"
          :class="$style.subTitle"
          :title="subTitle"
        >
          {{ subTitle }}
        </h5>
        <div :class="$style.badge">
          <slot
            name="badge"
          />
        </div>
      </header>
      <div :class="$style.body">
        <slot />
      </div>
    </div>
  </Card>
</template>

<script>
import { Card, TooltipIcon } from '@jumpcloud/ui-components';

export default {
  name: 'CardSettings',

  inject: ['$validator'],

  components: {
    Card,
    TooltipIcon,
  },

  props: {
    alignBottom: Boolean,
    error: Boolean,
    icon: {
      type: Object,
      default: () => ({}),
    },
    iconComponent: {
      default: null,
      type: Object,
    },
    showTitle: {
      default: true,
      type: Boolean,
    },
    subTitle: {
      default: null,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    tooltip: {
      required: false,
      type: Object,
      default: null,
    },
  },
};
</script>

<style module>
@value (jcError, jcGrey100) from '~css/brand-colors.css';

.badge {
  text-align: right;
}

.card {
  display: flex;
  min-height: 100%;
  position: relative;
  width: 100%;
}

.error {
  border-color: jcError;
}

.content {
  flex: 1 1 100%;
}

.alignBottom {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  justify-content: space-between;
}

.header.header {
  align-items: flex-end;
  display: grid;
  grid-gap: var(--jc-spacer-x-small);
  grid-template:
    'title tooltip' auto
    'subtitle subtitle' auto /
    auto 1fr;
  min-width: 0;
}

.title.title {
  font-size: 18px;
  font-weight: 700;
  grid-area: title;
  margin: 0;
}

.subTitle.subTitle {
  font-weight: 400;
  grid-area: subtitle;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.icon {
  align-self: flex-start;
  flex: 0 0 auto;
  margin-right: var(--jc-spacer-x-small);
  width: 20px;
}

.iconWithBackground {
  align-items: center;
  background-color: jcGrey100;
  border-radius: 50%;
  display: flex;
  height: 32px;
  justify-content: center;
  margin-right: var(--jc-spacer-x-small);
  min-width: 32px;
}

.body {
  padding: 10px 0 0;
}

.tooltipContainer {
  grid-area: tooltip;
  margin: 0;
}

.tooltipIcon {
  font-size: 14px;
}

.headerStyle {
  display: inline-flex;
  padding-bottom: var(--jc-spacer-x-small);
}
</style>
